import { useQuery as m$1 } from './contact-channels37.js';
import { useContactChannelsContext as z } from './contact-channels14.js';
import { getChannelsData as i } from './contact-channels61.js';

const m=(e=true)=>{const{locale:t}=z();return m$1({queryKey:["channels-data"],queryFn:()=>i(t),staleTime:1/0,gcTime:1/0,retry:3,enabled:e})};

export { m as useChannelsData };
//# sourceMappingURL=contact-channels39.js.map
